export default __webpack_public_path__ + "static/media/cooling-tower.eb025a67.jpg";